import { render, staticRenderFns } from "./headFirstWidge2.vue?vue&type=template&id=08858ee4&scoped=true"
import script from "./headFirstWidge2.vue?vue&type=script&lang=js"
export * from "./headFirstWidge2.vue?vue&type=script&lang=js"
import style0 from "./headFirstWidge2.vue?vue&type=style&index=0&id=08858ee4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08858ee4",
  null
  
)

export default component.exports